/*
 * Authors: mariushirjanu, Triadi
 * Created: 08/11/2023
 */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IObject } from '../../../../../type_definitions/datatypes';
import { BrowselistCode, BrowseListConfigService, IBrowseListConfig } from '../../../../shared/browselists/browselists-config.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { StateService } from '@uirouter/angular';
import { GridOptions } from 'ag-grid-community';
import { STATE_BPPROFILES_VENDOR_ACCREDITATIONS } from '../../../../shared/app-states';
import { TranslateService } from '@ngx-translate/core';
import { BPProfilesAccreditationsService } from './bp-profiles-accreditations.service';

const gridHeightOffset:string = '50px;.ui-layout-north;.ui-layout-resizer-north;.filter-fields;.fixed-to-top-container;.report-info;.actions-row';

@Component({
  selector: 'bp-profiles-accreditations',
  // display a normal report when the user doesn't have permissions (but still set reportId)
  template: `
    <report-wrapper
      [reportId]="!hasWritePermission ? browselistConfig.reportId : undefined"
      [browselistConfig]="hasWritePermission ? browselistConfig : undefined"
      [filters]="queryFilters"
      [showTitle]="false"
      [showActions]="hasWritePermission"
      [visibleColumns]="visibleColumns"
      [gridHeight]="gridHeightOffset"
      [height]="200"
      [gridOptions]="gridOptions">
    </report-wrapper>

    <div class="accreditations-actions double-space-top" *ngIf="disableActions">
      <button class="btn btn-primary float-end" translate [translateParams]="{ label: title }" (click)="goToAccreditations()">GA.BUTTONS.EDIT_LABEL</button>
      <span class="clear"></span>
    </div>
  `
})
export class BPProfilesAccreditationsComponent implements OnInit, OnDestroy {
  @Input() public accreditationType:string;
  @Input() public vendorId:number;
  @Input() public disableActions:boolean;
  @Input() public gridAutoHeight:boolean;

  public browselistConfig:IBrowseListConfig;
  public title:string;
  public queryFilters:IObject = {};
  public hasWritePermission:boolean;
  public gridOptions:GridOptions;
  public gridHeightOffset:string;
  public visibleColumns:string[] = [
    'Accreditation_name',
    'Accreditation_covered',
    'Accreditation_comment'
  ];

  constructor(
    private authService:AuthService,
    private browselistConfigService:BrowseListConfigService,
    private stateService:StateService,
    private bpProfilesService:BPProfilesService,
    private bpProfilesAccreditationsService:BPProfilesAccreditationsService,
    private translationService:TranslateService
  ) {}

  public ngOnInit():void {
    this.hasWritePermission = this.disableActions ? false : this.authService.viewWrite(this.stateService.current.data?.viewCode);
    this.gridOptions = {
      sideBar: false, // remove right sidebar
      overlayNoRowsTemplate: `<div class="ag-overlay-no-rows-center"><h2>${this.translationService.instant('GA.GENERAL.NO_RESULTS_FOUND')}</h2><div>` // change text when no results found
    };

    this.browselistConfig = {
      ...this.browselistConfigService.getConfig(BrowselistCode.ACCREDITATIONS),
      label: this.isVendorAccreditations ? this.translationService.instant('BPPROFILES.VENDOR_ACCREDITATIONS.TEXT') : this.translationService.instant('BPPROFILES.ENGINEER_ACCREDITATIONS.TEXT')
    };
    this.bpProfilesAccreditationsService.accreditationType = this.accreditationType;
    this.title = this.translationService.instant('BPPROFILES.OEM.ACCREDITATIONS.TITLE');

    this.gridHeightOffset = !this.gridAutoHeight ? gridHeightOffset : undefined;

    this.queryFilters = {
      Bp_nickname: this.bpProfilesService.activeProfile?.companyCountryId,
      Accreditation_type_ds: this.bpProfilesAccreditationsService.accreditationType,
      Vendor_com_name: this.vendorId,
      Accreditation_covered: '0,1' // both covered and not-covered
    };
  }

  public goToAccreditations():void {
    this.stateService.go(STATE_BPPROFILES_VENDOR_ACCREDITATIONS);
  }

  private get isVendorAccreditations():boolean {
    return this.stateService.current.name === STATE_BPPROFILES_VENDOR_ACCREDITATIONS;
  }

  public ngOnDestroy():void {
    this.bpProfilesAccreditationsService.clear();
  }
}